import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import TemplateSelectorQuoteBootstrap from './TemplateSelectorQuoteBootstrap';
import QuoteFormBootstrap from './QuoteFormBootstrap';
import QuotePreviewBootstrap from './QuotePreviewBootstrap';
import QuoteActionsBootstrap from './QuoteActionsBootstrap';
//import InvoiceAttachmentsBootstrap from './InvoiceAttachmentsBootstrap';
import { addDays, sub } from 'date-fns';
import { toast } from 'sonner';
import PageTitle from '../../../../layouts/PageTitle';
import { getApiUrl } from '../../../../../utils/ApiUtils';
import axios from '../../../../../services/AxiosInstance';
import { isEqual } from 'lodash';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { parseISO } from 'date-fns/esm';
import Swal from 'sweetalert2';
import { useInvoiceSettings } from '../../../../../context/InvoiceSettingsContext';

const QuoteGeneratorBootstrap = () => {
  const history = useHistory();
  const { companyId, quoteId } = useParams();
  const quoteRef = useRef(null);
  const skipNavigationWarningRef = useRef(false);
  const { invoiceSettings, isLoading: isLoadingSettings } = useInvoiceSettings();

  const [initialFormData, setInitialFormData] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [articles, setArticles] = useState([]);

  const [companySettings, setCompanySettings] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedTemplate, setSelectedTemplate] = useState("classic");
  const [deliveryMethod, setDeliveryMethod] = useState('download');
  const [deliveryDetails, setDeliveryDetails] = useState({
    email: '',
    phone: '',
    message: 'Här är din faktura enligt begäran.'
  });

  // const [formData, setFormData] = useState({
  //     quoteNumber: 'PLACEHOLDER-XXX',
  //     quoteDate: new Date(),
  //     validUntil: addDays(new Date(), 30),
  //     customer: null,
  //     items: [],
  //     notes: "Thank you for considering our services. This quote is valid for 30 days.",
  //     paymentInfo: '',
  //     paymentMethods: {},
  //     attachments: [],
  //     roundTotal: false,
  //     footerData: {
  //       col1: '',
  //       col2: '',
  //       col3: ''
  //     }
  //   });

  // Initial placeholder form data - minimally defined until settings are loaded
  const [formData, setFormData] = useState({
    quoteNumber: "PLACEHOLDER-XXX", // Will be updated from settings
    quoteDate: new Date(),
    validUntil: addDays(new Date(), 30), // Default 30 days, will update from settings
    customer: null,
    items: [],
    notes: "", // Will be updated from settings
    paymentInfo: '',
    paymentMethods: {}, // Will be updated from settings
    attachments: [],
    roundTotal: false,
    footerData: {
      col1: "",
      col2: "",
      col3: ""
    }
  });

  console.log('QuoteGenerator: Invoicesettings:', invoiceSettings);

  const isFormValid = !!formData.customer && formData.items.length > 0;

  // Initialize form data based on settings
  useEffect(() => {
    if (invoiceSettings && !quoteId) {
      // Don't override data if we're editing an existing invoice

      // 1. Generate placeholder invoice number
      const { prefix, padding, includeYear } = invoiceSettings.invoiceNumbering || {};
      let placeholderNumber = prefix || '';

      // Add year if configured
      if (includeYear) {
        const currentYear = new Date().getFullYear();
        placeholderNumber += currentYear + '-';
      }

      // Add placeholder 'X's for the number part
      placeholderNumber += 'X'.repeat(padding || 4);

      // 2. Calculate due date based on payment terms
      const validUntil = addDays(new Date(), invoiceSettings.defaultTerms?.paymentDays || 30);

      // 3. Generate notes with payment terms
      let notes = "Tack för ditt förtroende. ";

      // Payment terms
      if (invoiceSettings.defaultTerms?.paymentDays) {
        notes += `Betalning sker inom ${invoiceSettings.defaultTerms.paymentDays} dagar. `;
      }

      // Add late payment interest if specified
      if (invoiceSettings.defaultTerms?.lateFeePercentage) {
        notes += `Vid sen betalning debiteras dröjsmålsränta med ${invoiceSettings.defaultTerms.lateFeePercentage}%. `;
      }

      // Add F-skatt information if enabled
      if (invoiceSettings.defaultTerms?.fskattApproved) {
        notes += "Företaget innehar F-skattsedel. ";
      }

      // 4. Initialize payment methods from settings
      const paymentMethods = {
        bankgiro: invoiceSettings.paymentMethods?.bankgiro || false,
        plusgiro: invoiceSettings.paymentMethods?.plusgiro || false,
        paypal: invoiceSettings.paymentMethods?.paypal || false,
        swish: invoiceSettings.paymentMethods?.swish || false
      };

      // 5. Create footer data with company details and payment info
      // const footerData = {
      //   col1: `${companyDetails.name}\n${companyDetails.address?.street || ''}\n${companyDetails.address?.city || ''}, ${companyDetails.address?.state || ''} ${companyDetails.address?.zipCode || ''}`,
      //   col2: `Organisationsnummer: ${companyDetails.registrationNumber || ''}\nMomsreg.nr: ${companyDetails.vatNumber || ''}\nGodkänd för F-skatt: ${invoiceSettings.defaultTerms?.fskattApproved ? 'Ja' : 'Nej'}`,
      //   col3: 'Betalningsmetoder:\n'
      // };

      // Add payment methods to footer
      // if (paymentMethods.bankgiro && invoiceSettings.paymentMethods?.bankgiroNumber) {
      //   footerData.col3 += `Bankgiro: ${invoiceSettings.paymentMethods.bankgiroNumber}\n`;
      // }
      // if (paymentMethods.plusgiro && invoiceSettings.paymentMethods?.plusgiroNumber) {
      //   footerData.col3 += `Plusgiro: ${invoiceSettings.paymentMethods.plusgiroNumber}\n`;
      // }
      // if (paymentMethods.swish && invoiceSettings.paymentMethods?.swishNumber) {
      //   footerData.col3 += `Swish: ${invoiceSettings.paymentMethods.swishNumber}\n`;
      // }
      // if (paymentMethods.paypal && invoiceSettings.paymentMethods?.paypalEmail) {
      //   footerData.col3 += `PayPal: ${invoiceSettings.paymentMethods.paypalEmail}\n`;
      // }

      // 6. Update form data with all settings-based values
      const updatedFormData = {
        ...formData,
        quoteNumber: placeholderNumber,
        validUntil,
        notes: notes.trim(),
        paymentMethods,
        deliveryTerms: invoiceSettings.defaultTerms?.deliveryTerms || "Fritt vårt lager",
        latePaymentInterestRate: invoiceSettings.defaultTerms?.lateFeePercentage?.toString() || "8",
        //footerData
      };

      setFormData(updatedFormData);

      // Set initial form data after all settings have been applied
      setInitialFormData(JSON.parse(JSON.stringify(updatedFormData)));

      // 7. Set default template
      if (invoiceSettings.template?.defaultTemplate) {
        setSelectedTemplate(invoiceSettings.template.defaultTemplate);
      }

      // 8. Set default delivery method
      if (invoiceSettings.deliveryChannels?.defaultChannel) {
        setDeliveryMethod(invoiceSettings.deliveryChannels.defaultChannel);
      }

      // 9. Initialize email from setting if available
      if (invoiceSettings.deliveryChannels?.emailFrom) {
        setDeliveryDetails(prev => ({
          ...prev,
          email: invoiceSettings.deliveryChannels.emailFrom
        }));
      }
    }
  }, [invoiceSettings, quoteId, companyDetails, formData]);

  // Define handleSaveDraft with useCallback at the TOP of your component
  const handleSaveDraft = useCallback(async () => {
    if (!formData.customer) {
      toast.error('Vänligen välj en kund innan du sparar.');
      return null;
    }

    if (formData.items.length === 0) {
      toast.error('Lägg till minst en artikel innan du sparar.');
      return null;
    }

    setIsLoading(true);

    try {
      // Prepare data for API
      const dataToSend = {
        customerid: formData.customer.id,
        quoteId: formData.quoteId, // This will be null for new invoices
        status: 'Draft',
        currency: 'SEK',
        quoteDate: format(formData.quoteDate, 'yyyy-MM-dd'),
        deadline: format(formData.validUntil, 'yyyy-MM-dd'),
        delivery_terms: formData.deliveryTerms,
        late_pay_interest: formData.latePaymentInterestRate,
        rounding: formData.roundTotal ? 1 : 0,
        items: formData.items.map(item => ({
          productcode: item.name,
          description: item.description,
          quantity: item.quantity,
          unitprice: item.price,
          tax_rate: `${item.tax}%`,
          unit: item.unit || 'pcs',
          type: item.type || 'Service',
          // Only include item_id for existing items
          ...(item.item_id && { item_id: item.item_id })
        }))
      };

      let response;
      let savedQuoteId;

      if (!formData.quoteId) {
        console.log('Creating new quote draft');
        // Create new invoice
        const createInvoiceApiUrl = getApiUrl(`${companyId}/invoices`);
        response = await axios.post(createInvoiceApiUrl, dataToSend, { withCredentials: true });

        if (response.data.success) {
          savedQuoteId = response.data.quoteId;

          // Update formData with the new invoice ID
          const updatedFormData = {
            ...formData,
            quoteId: savedQuoteId,
            // Update invoice number if backend provides a formatted one
            quoteNumber: response.data.friendlyId || formData.quoteNumber
          };

          setFormData(updatedFormData);

          // Set initial form state to track changes - using deep copy
          setInitialFormData(JSON.parse(JSON.stringify(updatedFormData)));
          setHasUnsavedChanges(false);

          toast.success('Fakturautkast sparat');
        }
      } else {
        // Update existing invoice
        const updateInvoiceApiUrl = getApiUrl(`${companyId}/invoices/${formData.invoiceId}`);
        response = await axios.put(updateInvoiceApiUrl, dataToSend, { withCredentials: true });

        if (response.data.success) {
          savedQuoteId = formData.quoteId;

          // Set initial form state to track changes - using deep copy
          setInitialFormData(JSON.parse(JSON.stringify(formData)));
          setHasUnsavedChanges(false);

          toast.success('Fakturautkast uppdaterat');
        }
      }

      if (!response.data.success) {
        toast.error('Det gick inte att spara fakturautkastet');
        return null;
      }

      return savedQuoteId;
    } catch (error) {
      console.error('Error saving draft:', error);
      toast.error('Ett fel uppstod vid sparande av fakturautkast');
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [
    formData,
    companyId,
    setIsLoading,
    setFormData,
    setInitialFormData,
    setHasUnsavedChanges
  ]);

  // Fetch all required data when component mounts
  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        // Fetch all required data in parallel
        await Promise.all([
          fetchCompanySettings(),
          fetchArticles(),
          fetchCustomers(),
        ]);

      } catch (error) {
        console.error("Error fetching initial data:", error);
        toast.error("Ett fel uppstod vid hämtning av data");
      } finally {
        setIsLoading(false);
      }
    };

    if (companyId) {
      fetchAllData();
    }
  }, [companyId]);

  // Effect to check for unsaved changes - simplified and cleaner approach
  useEffect(() => {
    if (initialFormData) {
      // Use deep comparison to check for changes
      const hasChanges = !isEqual(formData, initialFormData);
      setHasUnsavedChanges(hasChanges);
    }
  }, [formData, initialFormData]);

  useEffect(() => {
    const unblock = history.block((promptLocation) => {
      if (skipNavigationWarningRef.current) {
        skipNavigationWarningRef.current = false;
        return true;
      }

      if (hasUnsavedChanges) {
        Swal.fire({
          title: 'Du har osparade ändringar!',
          text: 'Vill du spara utkastet innan du lämnar sidan?',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Avbryt',
          showDenyButton: true,
          denyButtonText: 'Fortsätt utan att spara',
          confirmButtonText: 'Spara utkast',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            handleSaveDraft()
              .then(() => {
                skipNavigationWarningRef.current = true;
                history.push(promptLocation.pathname);
              })
              .catch(() => {
                Swal.fire('Error', 'Failed to save draft. Navigation cancelled.', 'error');
              });
          } else if (result.isDenied) {
            skipNavigationWarningRef.current = true;
            history.push(promptLocation.pathname);
          }
        });
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [hasUnsavedChanges, history, handleSaveDraft]);

  // Handle browser/tab close
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = ''; // This string is shown in some browsers
        return ''; // This return string is also shown in some browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  // Fetch invoice data if we're in edit mode
  useEffect(() => {
    const fetchQuoteData = async () => {
      if (quoteId) {
        setIsLoading(true);
        try {
          // Fetch invoice details
          const response = await axios.get(
            getApiUrl(`${companyId}/quotes/${quoteId}`),
            { withCredentials: true }
          );

          console.log('Fetched invoice data:', response.data);

          if (response.data) {
            const invoiceData = response.data.data;

            // Parse dates from string to Date objects
            const invoiceDate = parseISO(invoiceData.invoicedate);
            const dueDate = parseISO(invoiceData.deadline);

            // Format the items to match the format used in the editor
            const formattedItems = invoiceData.items.map(item => ({
              item_id: item.item_id,
              name: item.productcode,
              description: item.description,
              quantity: item.quantity,
              price: item.unitprice,
              tax: item.tax_rate.replace('%', ''),
              unit: item.unit || 'pcs',
              type: item.type || 'Service',
              total: item.quantity * item.unitprice
            }));

            // If we have a customer, fetch the full customer details
            let customerDetails = null;
            if (invoiceData.customerid) {
              customerDetails = await fetchCustomerDetails(invoiceData.customerid);
            }

            // Determine payment methods based on invoice data and settings
            const paymentMethods = {
              bankgiro: invoiceSettings?.paymentMethods?.bankgiro || false,
              plusgiro: invoiceSettings?.paymentMethods?.plusgiro || false,
              paypal: invoiceSettings?.paymentMethods?.paypal || false,
              swish: invoiceSettings?.paymentMethods?.swish || false
            };

            // Create footer data
            const footerData = {
              col1: `${companyDetails.name}\n${companyDetails.address?.street || ''}\n${companyDetails.address?.city || ''}, ${companyDetails.address?.state || ''} ${companyDetails.address?.zipCode || ''}`,
              col2: `Organisationsnummer: ${companyDetails.registrationNumber || ''}\nMomsreg.nr: ${companyDetails.vatNumber || ''}\nGodkänd för F-skatt: ${invoiceSettings?.defaultTerms?.fskattApproved ? 'Ja' : 'Nej'}`,
              col3: 'Betalningsmetoder:\n'
            };

            // Add payment methods to footer
            if (paymentMethods.bankgiro && invoiceSettings?.paymentMethods?.bankgiroNumber) {
              footerData.col3 += `Bankgiro: ${invoiceSettings.paymentMethods.bankgiroNumber}\n`;
            }
            if (paymentMethods.plusgiro && invoiceSettings?.paymentMethods?.plusgiroNumber) {
              footerData.col3 += `Plusgiro: ${invoiceSettings.paymentMethods.plusgiroNumber}\n`;
            }
            if (paymentMethods.swish && invoiceSettings?.paymentMethods?.swishNumber) {
              footerData.col3 += `Swish: ${invoiceSettings.paymentMethods.swishNumber}\n`;
            }
            if (paymentMethods.paypal && invoiceSettings?.paymentMethods?.paypalEmail) {
              footerData.col3 += `PayPal: ${invoiceSettings.paymentMethods.paypalEmail}\n`;
            }

            // Create updated form data object
            const updatedFormData = {
              quoteId: quoteId,
              quoteNumber: invoiceData.friendly_id || invoiceData.invoicenumber || 'Draft',
              invoiceDate: invoiceDate,
              dueDate: dueDate,
              customer: customerDetails,
              items: formattedItems,
              notes: invoiceData.notes || '',
              paymentInfo: invoiceData.payment_info || '',
              paymentMethods: paymentMethods,
              deliveryTerms: invoiceData.delivery_terms || (invoiceSettings?.defaultTerms?.deliveryTerms || "Fritt vårt lager"),
              latePaymentInterestRate: invoiceData.late_pay_interest ?
                invoiceData.late_pay_interest.replace('%', '') :
                (invoiceSettings?.defaultTerms?.lateFeePercentage?.toString() || "8"),
              roundTotal: invoiceData.rounding === 1,
              footerData: footerData,
              attachments: invoiceData.attachments || []
            };

            // Update the form data
            setFormData(updatedFormData);

            // Set initial form data to track changes - deep copy
            setInitialFormData(JSON.parse(JSON.stringify(updatedFormData)));
            setHasUnsavedChanges(false);

            toast.success('Fakturautkast laddat');
          }
        } catch (error) {
          console.error('Error fetching invoice data:', error);
          toast.error('Kunde inte ladda fakturadata');
        } finally {
          setIsLoading(false);
        }
      }
    };

    if (quoteId && invoiceSettings) {
      console.log('Fetching invoice data for ID:', quoteId);
      fetchQuoteData();
    }
  }, [quoteId, companyId, invoiceSettings, companyDetails]);

  // API functions to fetch data
  const fetchCompanySettings = async () => {
    try {
      const settingsApiUrl = getApiUrl(`${companyId}/settings/bulk`);
      const { data } = await axios.post(
        settingsApiUrl,
        { keys: ['default_payment_terms', 'default_late_interest_rate', 'company_details'] },
        { withCredentials: true }
      );

      console.log('Fetched company settings:', data);

      if (data && data.settings) {
        setCompanySettings(data.settings);

        // If company details are available, update state
        if (data.settings.company_details) {
          try {
            const companyData = data.settings.company_details;
            setCompanyDetails(companyData);
          } catch (e) {
            console.error('Error parsing company details:', e);
          }
        }
      }

      return data.settings;
    } catch (error) {
      console.error('Error fetching company settings:', error);
      return null;
    }
  };

  const fetchArticles = async () => {
    try {
      const articlesApiUrl = getApiUrl(`${companyId}/articles`);
      const { data } = await axios.get(articlesApiUrl, { withCredentials: true });

      console.log('Fetched articles:', data);

      if (data && data.data) {
        setArticles(data.data);
        return data.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching articles:', error);
      return [];
    }
  };

  const fetchCustomers = async () => {
    try {
      const customersApiUrl = getApiUrl(`${companyId}/sales/customers`);
      const { data } = await axios.get(customersApiUrl, { withCredentials: true });

      console.log('Fetched customers:', data);

      if (data) {
        setCustomers(data);
        return data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching customers:', error);
      return [];
    }
  };

  const fetchCustomerDetails = async (customerId) => {
    try {
      const customerDetailsApi = getApiUrl(`${companyId}/sales/customers/${customerId}`);
      const { data } = await axios.get(customerDetailsApi, { withCredentials: true });

      console.log('Fetched customer details:', data);

      return data;
    } catch (error) {
      console.error('Failed to fetch full customer details:', error);
      return null;
    }
  };

  // Event handlers
  const handleFormDataChange = (data) => {
    setFormData({
      ...formData,
      ...data,
    });
  };

  const handleDeliveryMethodChange = (method) => {
    setDeliveryMethod(method);
  };

  const handleDeliveryDetailsChange = (details) => {
    setDeliveryDetails({
      ...deliveryDetails,
      ...details
    });
  };

  const handlePaymentMethodChange = (method) => {
    handleFormDataChange({
      paymentMethods: {
        ...formData.paymentMethods,
        [method]: !formData.paymentMethods[method]
      }
    });
  };

  const handleAttachmentsChange = (attachments) => {
    handleFormDataChange({ attachments });
  };

  const handleSelectTemplate = (templateId) => {
    if (templateId) {
      setSelectedTemplate(templateId);
      // Animate the preview when template changes
      if (quoteRef.current) {
        quoteRef.current.classList.add('scale-in');
        setTimeout(() => {
          quoteRef.current?.classList.remove('scale-in');
        }, 300);
      }
    }
  };

  const handlePublish = async () => {
    // Basic validation
    if (!formData.customer) {
      toast.error('Välj en kund innan du publicerar fakturan');
      return;
    }

    if (formData.items.length === 0) {
      toast.error('Lägg till minst en artikel innan du publicerar');
      return;
    }

    // Validate delivery method details
    if (deliveryMethod === 'email' && !deliveryDetails.email) {
      toast.error('Ange en e-postadress för e-postleverans');
      return;
    }

    if (deliveryMethod === 'sms' && !deliveryDetails.phone) {
      toast.error('Ange ett telefonnummer för SMS-leverans');
      return;
    }

    try {
      // First ensure we have a saved invoice
      let invoiceIdToPublish = formData.quoteId;

      if (!invoiceIdToPublish) {
        // No saved invoice yet, ask if user wants to save first
        const confirmSave = window.confirm(
          'Fakturan måste sparas innan den kan publiceras. Vill du spara nu?'
        );

        if (!confirmSave) {
          return;
        }

        // Save draft first
        invoiceIdToPublish = await handleSaveDraft();

        if (!invoiceIdToPublish) {
          toast.error('Kunde inte spara fakturan. Publicering avbruten.');
          return;
        }
      } else if (hasUnsavedChanges) {
        // We have an invoice ID but there are unsaved changes
        const confirmSave = window.confirm(
          'Du har osparade ändringar. Vill du spara innan publicering?'
        );

        if (confirmSave) {
          await handleSaveDraft();
        }
      }

      // Now publish the invoice
      const publishInvoiceApiUrl = getApiUrl(`${companyId}/invoices/${invoiceIdToPublish}/publish`);

      const payload = {
        invoiceId: invoiceIdToPublish,
        action: deliveryMethod,
        email: deliveryMethod === 'email' ? deliveryDetails.email : undefined,
        phone: deliveryMethod === 'sms' ? deliveryDetails.phone : undefined,
        subject: deliveryMethod === 'email' ? deliveryDetails.subject : undefined,
        message: (deliveryMethod === 'email' || deliveryMethod === 'sms') ? deliveryDetails.message : undefined,
        paymentMethods: formData.paymentMethods,
        selectedTemplate: selectedTemplate
      };

      const response = await axios.post(
        publishInvoiceApiUrl,
        payload,
        {
          withCredentials: true,
          responseType: deliveryMethod === 'download' ? 'blob' : 'json',
        }
      );

      // Handle download if that was the selected delivery method
      if (deliveryMethod === 'download' && response.data) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `faktura-${invoiceIdToPublish}.pdf`;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }

      toast.success('Fakturan har publicerats!');

      // Redirect to invoices list after successful publication
      setTimeout(() => {
        skipNavigationWarningRef.current = true;
        history.push(`/${companyId}/invoices`);
      }, 1500);
    } catch (error) {
      console.error('Error publishing invoice:', error);
      toast.error('Det gick inte att publicera fakturan. Försök igen.');
    }
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="pb-4 d-flex justify-content-between align-items-center">
        <PageTitle
          activeMenu={quoteId ? "Redigera Fakturautkast" : "Skapa Faktura"}
          motherMenu="Fakturor"
        />
        <button
          className="btn btn-light"
          onClick={() => {
            if (hasUnsavedChanges) {
              if (window.confirm('Du har osparade ändringar. Är du säker på att du vill lämna sidan?')) {
                skipNavigationWarningRef.current = true;
                history.push(`/${companyId}/invoices`);
              }
            } else {
              history.push(`/${companyId}/invoices`);
            }
          }}
        >
          <i className="fa fa-arrow-left mr-2"></i> Tillbaka till fakturalistan
        </button>
      </div>

      {/*<div className="mb-4">
        <QuoteActionsBootstrap
          invoiceRef={quoteRef}
          onSaveDraft={handleSaveDraft}
          onPublish={handlePublish}
          isValid={isFormValid}
          deliveryMethod={deliveryMethod}
          onDeliveryMethodChange={handleDeliveryMethodChange}
          deliveryDetails={deliveryDetails}
          onDeliveryDetailsChange={handleDeliveryDetailsChange}
          paymentMethods={formData.paymentMethods}
          onPaymentMethodChange={handlePaymentMethodChange}
          availableDeliveryMethods={invoiceSettings?.deliveryChannels}
          hasUnsavedChanges={hasUnsavedChanges}
          invoiceSettings={invoiceSettings}
        />
      </div>*/}

      {/*<div className="mb-4">
        <TemplateSelectorQuoteBootstrap
          selectedTemplate={selectedTemplate}
          onSelectTemplate={handleSelectTemplate}
          availableTemplates={invoiceSettings?.template}
        />
      </div>*/}

      <div className="section-header mb-3 mt-4">
        <h5 className="mb-0">Fakturadetaljer</h5>
        <p className="text-muted small mb-0">Fyll i information om kund, produkter, och betalningsvillkor. Alla obligatoriska fält måste fyllas i innan fakturan kan publiceras.</p>
      </div>

      <div className="flex-grow-1 h-100">
        {/*<div className="bg-white rounded shadow-sm p-4 h-100 overflow-auto">
          <QuoteFormBootstrap
            formData={formData}
            onFormDataChange={handleFormDataChange}
            availableItems={articles.length > 0 ? articles : null}
            customers={customers}
            isLoading={isLoading}
            invoiceSettings={invoiceSettings}
            onFetchCustomerDetails={fetchCustomerDetails}
          />
        </div>*/}

        <div className="section-header mt-5 mb-3">
          <h5 className="mb-0">Bilagor</h5>
          <p className="text-muted small mb-0">Lägg till relevanta dokument som ska skickas tillsammans med fakturan, som specifikationer eller avtal.</p>
        </div>

        {/*<div className="bg-white rounded shadow-sm p-4 h-100 overflow-auto mt-4">
          <InvoiceAttachmentsBootstrap
            attachments={formData.attachments}
            onAttachmentsChange={handleAttachmentsChange}
          />
        </div>*/}

        {/* Preview component is now hidden until implementation is complete */}
        {/*<div className="d-none">
          <QuotePreviewBootstrap
            ref={quoteRef}
            templateId={selectedTemplate}
            customer={formData.customer}
            company={companyDetails}
            invoiceNumber={formData.invoiceNumber}
            invoiceDate={formData.invoiceDate}
            dueDate={formData.dueDate}
            items={formData.items}
            notes={formData.notes}
            paymentInfo={formData.paymentInfo}
            paymentMethods={formData.paymentMethods}
            roundTotal={formData.roundTotal}
            footerData={formData.footerData}
            attachments={formData.attachments}
          />
        </div>*/}
      </div>

      {hasUnsavedChanges && (
        <div className="position-fixed bottom-0 start-0 w-100 bg-light border-top p-2 text-center">
          <span className="text-warning me-2">
            <i className="bi bi-exclamation-triangle"></i>
          </span>
          Du har osparade ändringar
          <button className="btn btn-sm btn-primary ms-3" onClick={handleSaveDraft}>
            Spara utkast
          </button>
        </div>
      )}
    </div>
  );
};

export default QuoteGeneratorBootstrap;



// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useParams, useHistory } from 'react-router-dom';
// import TemplateSelectorQuoteBootstrap from './TemplateSelectorQuoteBootstrap';
// import QuoteFormBootstrap from './QuoteFormBootstrap';
// import QuoteActionsBootstrap from './QuoteActionsBootstrap';
// import { addDays } from 'date-fns';
// import axios from '../../../../../services/AxiosInstance';
// import { Toast } from 'bootstrap';
// import { toast } from 'sonner';
// import { format, parseISO } from 'date-fns';
// import { useInvoiceSettings } from '../../../../../context/InvoiceSettingsContext';


// const QuoteGeneratorBootstrap = () => {

//   const { companyId, quoteId } = useParams();
//   const history = useHistory();
//   const quoteRef = useRef(null);
//   const { invoiceSettings } = useInvoiceSettings();

//   const [companyData, setCompanyData] = useState(null);
//   const [availableCustomers, setAvailableCustomers] = useState([]);
//   const [availableItems, setAvailableItems] = useState([]);
//   const [quoteSettings, setQuoteSettings] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [quote, setQuote] = useState(null);
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

//   const [activeTab, setActiveTab] = useState("editor");
//   const [isFormValid, setIsFormValid] = useState(false);
//   const [selectedTemplate, setSelectedTemplate] = useState("classic");
//   const [deliveryMethod, setDeliveryMethod] = useState('download');
//   const [deliveryDetails, setDeliveryDetails] = useState({
//     email: '',
//     phone: '',
//     message: 'Here is your quote as requested.'
//   });



//   const [formData, setFormData] = useState({
//     quoteNumber: 'PLACEHOLDER-XXX',
//     quoteDate: new Date(),
//     validUntil: addDays(new Date(), 30),
//     customer: null,
//     items: [],
//     notes: "Thank you for considering our services. This quote is valid for 30 days.",
//     paymentInfo: '',
//     paymentMethods: {},
//     attachments: [],
//     roundTotal: false,
//     footerData: {
//       col1: '',
//       col2: '',
//       col3: ''
//     }
//   });

//   //const isFormValid = !!formData.customer && formData.items.length > 0;



//   // Fetch company data
//   useEffect(() => {
//     const fetchCompanyData = async () => {
//       try {
//         const response = await axios.get(`/api/companies/${companyId}`);
//         setCompanyData(response.data);

//         // Initialize footer data with company info
//         setFormData(prev => ({
//           ...prev,
//           footerData: {
//             col1: `${response.data.company_name}\n${response.data.address}\n${response.data.zipcode} ${response.data.city}`,
//             col2: `Registration No: ${response.data.registration_number || ''}\nVAT Number: ${response.data.vat_number || ''}`,
//             col3: 'Payment Methods:\nBank Transfer'
//           }
//         }));
//       } catch (err) {
//         console.error('Error fetching company data:', err);
//         setError('Failed to load company data');
//       }
//     };

//     fetchCompanyData();
//   }, [companyId]);

//   // Fetch customers
//   useEffect(() => {
//     const fetchCustomers = async () => {
//       try {
//         const response = await axios.get(`/api/companies/${companyId}/customers`);
//         setAvailableCustomers(response.data);
//       } catch (err) {
//         console.error('Error fetching customers:', err);
//         setError('Failed to load customers');
//       }
//     };

//     fetchCustomers();
//   }, [companyId]);

//   // Fetch products/items
//   useEffect(() => {
//     const fetchItems = async () => {
//       try {
//         const response = await axios.get(`/api/companies/${companyId}/products`);
//         setAvailableItems(response.data);
//       } catch (err) {
//         console.error('Error fetching products:', err);
//         setError('Failed to load products');
//       }
//     };

//     fetchItems();
//   }, [companyId]);

//   // Fetch quote settings
//   // useEffect(() => {
//   //   const fetchQuoteSettings = async () => {
//   //     try {
//   //       const response = await axios.get(`/api/companies/${companyId}/settings/quotes`);
//   //       setQuoteSettings(response.data);

//   //       // Initialize selected template and delivery method from settings
//   //       if (response.data.template?.defaultTemplate) {
//   //         setSelectedTemplate(response.data.template.defaultTemplate);
//   //       }

//   //       if (response.data.deliveryChannels?.defaultChannel) {
//   //         setDeliveryMethod(response.data.deliveryChannels.defaultChannel);
//   //       }
//   //     } catch (err) {
//   //       console.error('Error fetching quote settings:', err);
//   //       // Don't set error - settings might be optional
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchQuoteSettings();
//   // }, [companyId]);

//   // Fetch quote if editing
//   useEffect(() => {
//     if (quoteId) {
//       const fetchQuote = async () => {
//         setLoading(true);
//         try {
//           const response = await axios.get(`/api/companies/${companyId}/quotes/${quoteId}`);
//           setQuote(response.data);

//           // Format the quote data for our form
//           const quoteData = response.data;
//           setFormData({
//             quoteNumber: quoteData.quote_number,
//             quoteDate: parseISO(quoteData.quote_date),
//             validUntil: parseISO(quoteData.valid_until),
//             customer: quoteData.customer,
//             items: quoteData.items.map(item => ({
//               id: item.id,
//               productcode: item.product_code,
//               description: item.description,
//               quantity: item.quantity,
//               unitprice: item.unit_price,
//               tax_rate: `${item.tax_rate}%`,
//               discount: item.discount || 0
//             })),
//             notes: quoteData.notes || "Thank you for considering our services. This quote is valid for 30 days.",
//             paymentInfo: quoteData.payment_info || '',
//             paymentMethods: quoteData.payment_methods || {
//               bankTransfer: true,
//               creditCard: false,
//               swish: false,
//               bankgiro: false,
//               plusgiro: false
//             },
//             footerData: quoteData.footer_data || {
//               col1: '',
//               col2: '',
//               col3: ''
//             }
//           });

//           // Set template if available
//           if (quoteData.template) {
//             setSelectedTemplate(quoteData.template);
//           }
//         } catch (err) {
//           console.error('Error fetching quote:', err);
//           setError('Failed to load quote data');
//         } finally {
//           setLoading(false);
//         }
//       };

//       fetchQuote();
//     } else {
//       // If creating a new quote, generate a number
//       const generateQuoteNumber = async () => {
//         try {
//           const response = await axios.get(`/api/companies/${companyId}/quotes/next-number`);
//           setFormData(prev => ({
//             ...prev,
//             quoteNumber: response.data.next_number
//           }));
//         } catch (err) {
//           console.error('Error generating quote number:', err);
//           // Fallback to a placeholder
//           setFormData(prev => ({
//             ...prev,
//             quoteNumber: 'QUOTE-NEW'
//           }));
//         }
//       };

//       generateQuoteNumber();
//     }
//   }, [companyId, quoteId]);

//   // Track unsaved changes
//   useEffect(() => {
//     if (quote) {
//       // Compare current form with original quote to detect changes
//       setHasUnsavedChanges(true); // This should be a more complex comparison in a real app
//     } else if (formData.customer || formData.items.length > 0) {
//       setHasUnsavedChanges(true);
//     }
//   }, [formData, quote]);

//   // Form validation
//   useEffect(() => {
//     // Check if all required fields are filled
//     const hasCustomer = !!formData.customer;
//     const hasItems = formData.items.length > 0;
//     const hasValidItems = formData.items.every(item =>
//       (item.quantity > 0 && item.unitprice > 0) || item.type === 'Text'
//     );

//     setIsFormValid(hasCustomer && hasItems && hasValidItems);
//   }, [formData.customer, formData.items]);

//   // Validate form with error messages
//   const validateForm = useCallback(() => {
//     if (!formData.customer) {
//       toast.error('Please select a customer');
//       return false;
//     }

//     if (formData.items.length === 0) {
//       toast.error('Please add at least one item');
//       return false;
//     }

//     const invalidItems = formData.items.filter(item =>
//       item.type !== 'Text' && (item.quantity <= 0 || item.unitprice <= 0)
//     );

//     if (invalidItems.length > 0) {
//       toast.error('Please ensure all items have valid quantities and prices');
//       return false;
//     }

//     return true;
//   }, [formData.customer, formData.items]);

//   const handlePaymentMethodChange = useCallback((method) => {
//     handleFormDataChange({
//       paymentMethods: {
//         ...formData.paymentMethods,
//         [method]: !formData.paymentMethods[method]
//       }
//     });
//   }, []);

//   // Handler for form data changes
//   const handleFormDataChange = useCallback((newData) => {
//     setFormData(current => ({ ...current, ...newData }));
//     setHasUnsavedChanges(true);
//   }, []);

//   // Handler for delivery method changes
//   const handleDeliveryMethodChange = useCallback((method) => {
//     setDeliveryMethod(method);
//   }, []);

//   // Handler for delivery details changes
//   const handleDeliveryDetailsChange = useCallback((details) => {
//     setDeliveryDetails(prev => ({
//       ...prev,
//       ...details
//     }));
//   }, []);

//   // Handle template selection
//   const handleSelectTemplate = useCallback((templateId) => {
//     if (templateId) {
//       setSelectedTemplate(templateId);
//       // Animate the preview when template changes
//       if (quoteRef.current) {
//         quoteRef.current.classList.add('scale-in');
//         setTimeout(() => {
//           quoteRef.current?.classList.remove('scale-in');
//         }, 300);
//       }
//     }
//   }, []);

//   // Save draft handler
//   const handleSaveDraft = useCallback(async () => {
//     if (!formData.customer) {
//       toast.error('Please select a customer before saving');
//       return;
//     }

//     setLoading(true);

//     try {
//       const payload = {
//         quote_number: formData.quoteNumber,
//         quote_date: format(formData.quoteDate, 'yyyy-MM-dd'),
//         valid_until: format(formData.validUntil, 'yyyy-MM-dd'),
//         customer_id: formData.customer.id,
//         status: 'Draft',
//         items: formData.items.map(item => ({
//           product_code: item.productcode,
//           description: item.description,
//           quantity: item.quantity,
//           unit_price: item.unitprice,
//           tax_rate: parseFloat(item.tax_rate.replace('%', '')),
//           discount: item.discount || 0
//         })),
//         notes: formData.notes,
//         payment_info: formData.paymentInfo,
//         payment_methods: formData.paymentMethods,
//         footer_data: formData.footerData,
//         template: selectedTemplate
//       };

//       let response;
//       if (quoteId) {
//         // Update existing quote
//         response = await axios.put(`/api/companies/${companyId}/quotes/${quoteId}`, payload);
//       } else {
//         // Create new quote
//         response = await axios.post(`/api/companies/${companyId}/quotes`, payload);
//       }

//       toast.success('Quote draft saved successfully');
//       setHasUnsavedChanges(false);

//       // Redirect to edit page if it was a new quote
//       if (!quoteId && response.data.id) {
//         history.replace(`/${companyId}/edit-quote/${response.data.id}`);
//       }

//     } catch (err) {
//       console.error('Error saving quote:', err);
//       toast.error('Failed to save quote draft');
//     } finally {
//       setLoading(false);
//     }
//   }, [companyId, formData, quoteId, selectedTemplate, history]);

//   // Publish handler
//   const handlePublish = useCallback(async () => {
//     if (!validateForm()) {
//       return;
//     }

//     if (deliveryMethod === 'email' && !deliveryDetails.email) {
//       toast.error('Please provide an email address');
//       return;
//     }

//     if (deliveryMethod === 'sms' && !deliveryDetails.phone) {
//       toast.error('Please provide a phone number');
//       return;
//     }

//     setLoading(true);

//     try {
//       // First save/update the quote
//       const quotePayload = {
//         quote_number: formData.quoteNumber,
//         quote_date: format(formData.quoteDate, 'yyyy-MM-dd'),
//         valid_until: format(formData.validUntil, 'yyyy-MM-dd'),
//         customer_id: formData.customer.id,
//         status: 'Published',
//         items: formData.items.map(item => ({
//           product_code: item.productcode,
//           description: item.description,
//           quantity: item.quantity,
//           unit_price: item.unitprice,
//           tax_rate: parseFloat(item.tax_rate.replace('%', '')),
//           discount: item.discount || 0
//         })),
//         notes: formData.notes,
//         payment_info: formData.paymentInfo,
//         payment_methods: formData.paymentMethods,
//         footer_data: formData.footerData,
//         template: selectedTemplate
//       };

//       let quoteResponse;
//       if (quoteId) {
//         // Update existing quote
//         quoteResponse = await axios.put(`/api/companies/${companyId}/quotes/${quoteId}`, quotePayload);
//       } else {
//         // Create new quote
//         quoteResponse = await axios.post(`/api/companies/${companyId}/quotes`, quotePayload);
//       }

//       const savedQuoteId = quoteId || quoteResponse.data.id;

//       // Then handle the delivery
//       const deliveryPayload = {
//         action: deliveryMethod,
//         email: deliveryMethod === 'email' ? deliveryDetails.email : undefined,
//         phone: deliveryMethod === 'sms' ? deliveryDetails.phone : undefined,
//         subject: deliveryMethod === 'email' ? deliveryDetails.subject : undefined,
//         message: (deliveryMethod === 'email' || deliveryMethod === 'sms') ? deliveryDetails.message : undefined,
//         template: selectedTemplate
//       };

//       await axios.post(`/api/companies/${companyId}/quotes/${savedQuoteId}/deliver`, deliveryPayload);

//       let successMessage = "Quote published successfully";
//       if (deliveryMethod === 'email') {
//         successMessage = `Quote sent to ${deliveryDetails.email}`;
//       } else if (deliveryMethod === 'sms') {
//         successMessage = `Quote notification sent to ${deliveryDetails.phone}`;
//       } else if (deliveryMethod === 'print') {
//         successMessage = 'Quote sent to printer';
//       } else if (deliveryMethod === 'download') {
//         successMessage = 'Quote ready for download';

//         // Trigger download
//         window.open(`/api/companies/${companyId}/quotes/${savedQuoteId}/download?template=${selectedTemplate}`, '_blank');
//       }

//       toast.success(successMessage);
//       setHasUnsavedChanges(false);

//       // Redirect to quotes list
//       history.push(`/${companyId}/quotes`);

//     } catch (err) {
//       console.error('Error publishing quote:', err);
//       toast.error('Failed to publish quote');
//     } finally {
//       setLoading(false);
//     }
//   }, [companyId, deliveryDetails, deliveryMethod, formData, quoteId, selectedTemplate, validateForm, history]);


//   return (
//     <div className="d-flex flex-column h-100">
//       <div className="mb-4">
//         <QuoteActionsBootstrap
//           quoteRef={quoteRef}
//           onSaveDraft={handleSaveDraft}
//           onPublish={handlePublish}
//           isValid={isFormValid}
//           deliveryMethod={deliveryMethod}
//           onDeliveryMethodChange={handleDeliveryMethodChange}
//           deliveryDetails={deliveryDetails}
//           onDeliveryDetailsChange={handleDeliveryDetailsChange}
//           paymentMethods={formData.paymentMethods}
//           onPaymentMethodChange={handlePaymentMethodChange}
//           availableDeliveryMethods={invoiceSettings.deliveryChannels}
//           hasUnsavedChanges={hasUnsavedChanges}
//           invoiceSettings={invoiceSettings}
//         />
//       </div>

//       <div className="mb-4">
//         <TemplateSelectorQuoteBootstrap
//           selectedTemplate={selectedTemplate}
//           onSelectTemplate={handleSelectTemplate}
//         />
//       </div>

//       {/*<ul className="nav nav-tabs mb-4">
//         <li className="nav-item">
//           <button
//             className={`nav-link ${activeTab === 'editor' ? 'active' : ''}`}
//             onClick={() => setActiveTab('editor')}
//           >
//             <i className="bi bi-pencil me-2"></i>
//             Editor
//           </button>
//         </li>
//         <li className="nav-item">
//           <button
//             className={`nav-link ${activeTab === 'preview' ? 'active' : ''}`}
//             onClick={() => setActiveTab('preview')}
//           >
//             <i className="bi bi-eye me-2"></i>
//             Preview
//           </button>
//         </li>
//       </ul>*/}

//       <div className="section-header mb-3 mt-4">
//         <h5 className="mb-0">Offertdetaljer</h5>
//         <p className="text-muted small mb-0">Fyll i information om kund, produkter, och betalningsvillkor. Alla obligatoriska fält måste fyllas i innan Offerten kan publiceras och skickas.</p>
//       </div>

//       <div className="flex-grow-1 h-100">
//         <div className={`tab-content h-100 ${activeTab === 'editor' ? 'd-block' : 'd-none'}`}>
//           <div className="bg-white rounded shadow-sm p-4 h-100 overflow-auto">
//             <QuoteFormBootstrap
//               formData={formData}
//               onFormDataChange={handleFormDataChange}
//               availableItems={availableItems}
//               availableCustomers={availableCustomers}
//               loading={loading}
//             />
//           </div>
//         </div>

//         {/*<div className={`tab-content h-100 ${activeTab === 'preview' ? 'd-block' : 'd-none'}`}>
//           <QuotePreviewBootstrap
//             ref={quoteRef}
//             templateId={selectedTemplate}
//             customer={formData.customer}
//             company={companyDetails}
//             quoteNumber={formData.quoteNumber}
//             quoteDate={formData.quoteDate}
//             validUntil={formData.validUntil}
//             items={formData.items}
//             notes={formData.notes}
//             paymentInfo={formData.paymentInfo}
//             paymentMethods={formData.paymentMethods}
//             footerData={formData.footerData}
//           />
//         </div>*/}
//       </div>
//     </div>
//   );
// };

// export default QuoteGeneratorBootstrap;
